function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { sortDate } from '@bydesign-ui/utils';
import { RangeState } from '../util';
import { BaseDate } from './BaseDate';
import { PanelType } from './BasePanel';
export var RangeDate = function (_BaseDate) {
  _inherits(RangeDate, _BaseDate);

  var _super = _createSuper(RangeDate);

  function RangeDate() {
    var _this;

    _classCallCheck(this, RangeDate);

    _this = _super.apply(this, arguments);
    _this.value = [];
    _this.innerValue = [];
    _this.trying = false;
    _this.tryingDate = [];
    _this.tryingValid = true;
    _this.presetTrying = false;
    _this.presetTryingDate = [];
    _this.presetTryingValid = true;
    _this.offset = 0;
    return _this;
  }

  _createClass(RangeDate, [{
    key: "setRangePanelUpdate",
    value: function setRangePanelUpdate(updater) {
      this.onUpdatePanelDate = updater;
    }
  }, {
    key: "updateValue",
    value: function updateValue(value) {
      if (this.equalValue(this.value, value || [])) {
        if ((!value || !value.length) && !this.trying) {
          this.onUpdatePanelDate && this.onUpdatePanelDate(this, []);
        }

        return;
      }

      var old = this.value;
      this.value = sortDate(value || []);
      this.isValueValid = this.getIsValueValid(this.value);

      if (!this.equalValue(old, this.value)) {
        this.onUpdatePanelDate && this.onUpdatePanelDate(this, this.value);
      } else {
        this.repaintPanel();
      }
    }
  }, {
    key: "updateOptions",
    value: function updateOptions(options) {
      _get(_getPrototypeOf(RangeDate.prototype), "updateOptions", this).call(this, options);

      var offset = options.offset;

      if (offset != null) {
        this.offset = offset;
      }
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.value;
    }
  }, {
    key: "getTryingSelectedState",
    value: function getTryingSelectedState(date) {
      if (this.offset !== 0 && this.trying) {
        return this.calcSelectedState(date, this.tryingDate);
      }

      return RangeState.NONE;
    }
  }, {
    key: "getSelectedState",
    value: function getSelectedState(date) {
      if (this.offset === 0) {
        return this.calcSelectedState(date, this.trying ? this.tryingDate : this.presetTrying ? this.presetTryingDate : this.value);
      }

      return this.calcSelectedState(date, this.presetTrying ? this.presetTryingDate : this.value);
    }
  }, {
    key: "isDateSelected",
    value: function isDateSelected(date) {
      var range = this.presetTrying ? this.presetTryingDate : this.value;
      return this.calcSelectedState(date, range, PanelType.DATE) !== RangeState.NONE;
    }
  }, {
    key: "isMonthSelected",
    value: function isMonthSelected(date) {
      var range = this.presetTrying ? this.presetTryingDate : this.value;
      return this.calcSelectedState(date, range, PanelType.MONTH) !== RangeState.NONE;
    }
  }, {
    key: "isWeekSelected",
    value: function isWeekSelected(date) {
      var range = this.presetTrying ? this.presetTryingDate : this.value;
      return this.calcSelectedState(date, range, PanelType.WEEK) !== RangeState.NONE;
    }
  }, {
    key: "isYearSelected",
    value: function isYearSelected(date) {
      var range = this.presetTrying ? this.presetTryingDate : this.value;
      return this.calcSelectedState(date, range, PanelType.YEAR) !== RangeState.NONE;
    }
  }, {
    key: "setPanelSelected",
    value: function setPanelSelected(date, part) {
      var virtual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var disabled = this.isDisabled(date);

      if (disabled && !virtual) {
        return;
      }

      if (!this.offset) {
        this.setControlledPanelSelected(date, virtual);
      } else {
        this.setOffsetPanelSelected(date, virtual);
      }
    }
  }, {
    key: "revertPanelSelected",
    value: function revertPanelSelected() {
      this.innerValue = [];
      this.startValue = undefined;
      this.endValue = undefined;
    }
  }, {
    key: "resetTryingState",
    value: function resetTryingState() {
      this.trying = false;
      this.tryingDate = [];
      this.tryingValid = true;
    }
  }, {
    key: "setPresetTrying",
    value: function setPresetTrying(presetTrying) {
      this.presetTrying = true;
      this.presetTryingDate = presetTrying;
      this.presetTryingValid = this.getIsValueValid(presetTrying);
      this.repaintPanel();
    }
  }, {
    key: "resetPresetTrying",
    value: function resetPresetTrying() {
      this.presetTrying = false;
      this.presetTryingDate = [];
      this.presetTryingValid = true;
      this.repaintPanel();
    }
  }, {
    key: "isTrying",
    value: function isTrying() {
      return this.trying;
    }
  }, {
    key: "getInstance",
    value: function getInstance() {
      return {
        value: this.value,
        innerValue: this.innerValue,
        trying: this.trying,
        tryingDate: this.tryingDate
      };
    }
  }, {
    key: "isInvalidTryingDate",
    value: function isInvalidTryingDate() {
      if (this.trying && this.tryingDate.length === 2) {
        return !this.tryingValid;
      }

      return false;
    }
  }, {
    key: "equalValue",
    value: function equalValue(sourceValue, compareValue) {
      var _this2 = this;

      if (sourceValue.length !== compareValue.length) {
        return false;
      }

      var source = sortDate(sourceValue);
      var compare = sortDate(compareValue);
      return !source.some(function (item, i) {
        return !_this2.equalDate(item, compare[i]);
      });
    }
  }, {
    key: "getIsValueValid",
    value: function getIsValueValid(value) {
      if (!value.length) {
        return true;
      }

      var _sortDate = sortDate(value),
          _sortDate2 = _slicedToArray(_sortDate, 2),
          start = _sortDate2[0],
          end = _sortDate2[1];

      var date = start;
      var needRangeValid = this.needRangeValid;

      while (date.getTime() <= end.getTime()) {
        var disabled = this.isDisabled(date);

        if (needRangeValid && disabled) {
          return false;
        }

        if (!needRangeValid && !disabled) {
          return true;
        }

        date = this.nextDate(date);
      }

      return needRangeValid;
    }
  }, {
    key: "setTryingState",
    value: function setTryingState(date) {
      this.trying = true;
      this.tryingDate = sortDate([].concat(_toConsumableArray(this.innerValue), [date]));
      this.tryingValid = this.getIsValueValid(this.tryingDate);
      this.repaintPanel();
    }
  }, {
    key: "setControlledPanelSelected",
    value: function setControlledPanelSelected(date) {
      var virtual = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (virtual) {
        if (this.point === 'start') {
          if (!this.startValue && this.endValue) {
            this.setTryingState(date);
          }

          return;
        }

        if (this.point === 'end') {
          if (this.startValue && !this.endValue) {
            this.setTryingState(date);
          }

          return;
        }

        if (!this.innerValue.length) {
          return;
        }

        this.setTryingState(date);
        return;
      }

      if (this.point === 'start') {
        this.startValue = date;
        var start = this.startValue;
        var end = this.endValue;
        this.innerValue = end && sortDate([start, end]) || [start];
        this.setTryingState(this.innerValue[this.innerValue.length - 1]);
        this.emit('start-value-change', start, start !== this.innerValue[0]);

        if (this.innerValue.length === 2) {
          this.emit('value-change', this.innerValue);
        }

        return;
      }

      if (this.point === 'end') {
        this.endValue = date;
        var _start = this.startValue;
        var _end = this.endValue;
        this.innerValue = _start && sortDate([_start, _end]) || [_end];
        this.setTryingState(this.innerValue[this.innerValue.length - 1]);
        this.emit('end-value-change', _end, _end !== this.innerValue[1]);

        if (this.innerValue.length === 2) {
          this.emit('value-change', this.innerValue);
        }

        return;
      }

      this.innerValue.push(date);

      if (this.innerValue.length < 2) {
        this.setTryingState(date);
        this.emit('add-start-value', date);
        return;
      }

      this.innerValue = sortDate(this.innerValue);
      var valid = this.getIsValueValid(this.innerValue);

      if (valid) {
        this.resetTryingState();
        this.emit('value-change', this.innerValue);
        this.revertPanelSelected();
        return;
      }

      this.innerValue.pop();
      this.setTryingState(date);
    }
  }, {
    key: "calcSelectedState",
    value: function calcSelectedState(date, value, type) {
      if (value.length < 2) {
        return RangeState.NONE;
      }

      var _value = _slicedToArray(value, 2),
          start = _value[0],
          end = _value[1];

      if (this.lessThanDate(date, start, type) || this.greaterThanDate(date, end, type)) {
        return RangeState.NONE;
      }

      if (this.equalDate(date, end, type) && this.equalDate(date, start, type)) {
        return RangeState.SINGLE;
      }

      if (this.equalDate(start, date, type)) {
        return RangeState.START;
      }

      if (this.equalDate(end, date, type)) {
        return RangeState.END;
      }

      return RangeState.IN;
    }
  }, {
    key: "setOffsetPanelSelected",
    value: function setOffsetPanelSelected(date) {
      var virtual = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!this.offset) {
        return;
      }

      var endDate = this.offset > 0 ? this.nextDate(date, Math.abs(this.offset) - 1) : this.prevDate(date, Math.abs(this.offset) - 1);
      var value = sortDate([date, endDate]);
      var valid = this.getIsValueValid(value);

      if (virtual || !valid) {
        this.trying = true;
        this.tryingDate = value;
        this.tryingValid = valid;
        this.repaintPanel();
        return;
      }

      this.resetTryingState();
      this.emit('value-change', value);
    }
  }]);

  return RangeDate;
}(BaseDate);